import { TCountryCode } from '../NewPassengerProperty/types'

export interface ISelectPassengerPropertyProps {
  onChange: (value: string) => void
  value: string
  disabled?: boolean
  errors?: string
  onBlur?: (event: React.FocusEvent<unknown>) => void
  touched?: boolean
  countryCode: TCountryCode
}

export enum EPassengerProperty {
  MILITARY = 'military',
  STUDENT = 'student',
  TEACHER = 'teacher',
  WHEELCHAIR = 'wheelchair',
  DISABILITY = 'disability',
  VETERAN = 'veteran'
}

export type IPassengerPropertyOptions = {
  US: EPassengerProperty[]
  MX: EPassengerProperty[]
}
